import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_SUBCONTRACTOR} from '../../constants';

export default {
  id: 'ACCES_DOSS',
  title: 'Comment accéder aux archives de mon fournisseur ?',
  description: '',
  categories: [CONTENT_CATEGORY_SUBCONTRACTOR],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Les archives correspondent aux documents valides. Ils sont stockés pour une durée de 15 ans.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Depuis le dossier de votre fournisseur, cliquez sur Archives.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_ACCES_DOSS/FR_ACCES_DOSS.png`
  }]
};
